import { LANG } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        lang: constants.LANG.EN,
    }
}

const langReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LANG.SET_LANG:
            return Object.assign({}, {
                ...state,
                ui: {
                    ...state.ui,
                    lang: action.lang,
                }
            })
        default:
            return state
    }
}

export default langReducer